import React, { useCallback, useEffect, useRef, useState } from 'react'
import microsoft from "../../Assets/images/microsoft.svg"
import google from "../../Assets/images/google.svg"
import apple from "../../Assets/images/apple-icon.svg"
import { decodeID, encodeID, getBrowserType, saveToStorage } from '../../utils/Helper'
import axios from 'axios'
import {
  LoginSocialGoogle,
  LoginSocialMicrosoft,
  IResolveParams,
  LoginSocialApple,
} from 'reactjs-social-login';
import { Config } from '../../config/Config'
import AppleLogin from 'react-apple-login'

import {
  GoogleLoginButton,
  MicrosoftLoginButton,
  AppleLoginButton,
} from 'react-social-login-buttons';
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import FrontLoader from './FrontLoader'
import { useLocation } from 'react-router-dom'
import { LanguageConstants } from '../../constants/LanguageConstants'
function SocialLogin() {
  const social_login = useMakeRequest()
  const REDIRECT_URI = Config?.REACT_BASE_URL;

  const google_client_id = decodeID(Config.GOOGLE_SOCIAL_LOGIN)
  const apple_client_id = decodeID(Config.APPLE_CLIENT_SECRET)
  const loaction  = useLocation()

  const [provider, setProvider] = useState('');
  const [profile, setProfile] = useState<any>({});

  const onLoginStart = useCallback(() => {
    // alert("login start");
  }, []);

  const onLogoutFailure = useCallback(() => {
    // alert("logout fail");
  }, []);

  const onLogoutSuccess = useCallback(() => {
    setProfile(null);
    setProvider("");
    alert("logout success");
  }, []);

  useEffect(()=>{
    if(profile?.access_token){
      const payload = {
        email:profile?.email,
        name:profile?.name,
        social_id:profile?.sub,
        social_type:"Google"
      }
      social_login.makeRequest({ payload, url: ApiConstants?.Social_login, toastStatus: true })
    }
  },[profile?.access_token])

  useEffect(()=>{
  if (social_login?.status) {
      saveToStorage({ key: "access_token", value: social_login?.data?.access_token })
      window.location.href = `${Config?.BASE_URL}/`;
    }
  },[social_login.status])

  return (
    <>
    {social_login.loading ? <FrontLoader/> : null}
      <div className="or-login-area">
        <div className="or-line">
          <span className="txt">{loaction?.pathname == '/login'  ? LanguageConstants?.LOGIN_WITH : LanguageConstants?.SINGUP_WITH }</span>
        </div>
        <ul className="social-footer">
          {/* <li>
            <div><img src={microsoft} alt="facebook icon" /></div>
            <LoginSocialMicrosoft
          client_id={process.env.REACT_APP_MICROSOFT_APP_ID || ''}
          redirect_uri={REDIRECT_URI}
          onLoginStart={onLoginStart}
          onResolve={({ provider, data }: IResolveParams) => {
            setProvider(provider);
            setProfile(data);
          }}
          onReject={(err: any) => {
            console.log(err);
          }}
        >
          <MicrosoftLoginButton />
        </LoginSocialMicrosoft>
          </li> */}
          <li>
            <div ><img src={google} alt="google icon" /></div>
            <LoginSocialGoogle
              client_id={google_client_id || ''}
              onLoginStart={onLoginStart}
              scope="profile email"
              redirect_uri={REDIRECT_URI}
              onResolve={({ provider, data }: IResolveParams) => {
                setProvider(provider);
                setProfile(data);
              }}
              onReject={err => {
                console.log(err);
              }}
            >
              <GoogleLoginButton />
            </LoginSocialGoogle>
          </li>
          {getBrowserType(navigator.userAgent)?.platform == 'Mac' ? 
          <li>
            <div><img src={apple} alt="apple icon" /></div>
            <LoginSocialApple
              client_id={apple_client_id}
              redirect_uri={REDIRECT_URI}
              onLoginStart={onLoginStart}
              onResolve={({ provider, data }) => {
                setProvider(provider);
                setProfile(data);
                console.log('Apple login data:', data);
              }}
              onReject={(err) => {
                console.error('Apple login error:', err);
              }}

            >
              <AppleLoginButton />
            </LoginSocialApple>
          </li>
            :null}          </ul>
      </div>
    </>
  )
}

export default SocialLogin